<template>
	<nav
		v-if="localPaginator.totalElements > localPaginator.elementsPerPage"
		class="list-paginator display-flex justify-content-center align-items-center mt-100 mt-150-md heading-6"
	>
		<BaseButtonIconOnly
			icon="chevron"
			icon-dir="left"
			data-test="list-paginator-previous"
			class="mr-100"
			:disabled="!enableBoundaries && firstPage"
			@click="previousPage"
		/>
		<span data-test="pagination-state"> Page {{ localPaginator.currentPage + 1 }} of {{ pageCount }} </span>
		<BaseButtonIconOnly
			icon="chevron"
			icon-dir="right"
			class="ml-100"
			:disabled="!enableBoundaries && lastPage"
			data-test="list-paginator-next"
			@click="nextPage"
		/>
	</nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Paginator from '@classes/Paginator';
interface Props {
	paginator: Paginator;
	enableBoundaries?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
	enableBoundaries: false
});
interface Emits {
	(e: 'update:paginator', value: Paginator): void;
	(e: 'paginated'): void;
	(e: 'nextPage'): void;
	(e: 'previousPage'): void;
}
const emit = defineEmits<Emits>();

const localPaginator = computed((): Paginator => {
	return props.paginator.clone();
});

const pageCount = computed((): number => {
	return localPaginator.value.pageCount;
});

const firstPage = computed((): boolean => {
	return localPaginator.value.currentPage === 0;
});

const lastPage = computed((): boolean => {
	return localPaginator.value.currentPage === pageCount.value - 1;
});

function updateParentObject(): void {
	emit('update:paginator', localPaginator.value);
}

function nextPage(): void {
	localPaginator.value.incrementPage();
	updateParentObject();
	emit('paginated');
	emit('nextPage');
}

function previousPage(): void {
	localPaginator.value.decrementPage();
	updateParentObject();
	emit('paginated');
	emit('previousPage');
}
</script>
